import { Component } from '@angular/core';

@Component({
  selector: 'ngx-time-estimates',
  templateUrl: './time-estimates.component.html',
  styleUrls: ['./time-estimates.component.scss']
})
export class TimeEstimatesComponent {

}
